import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en_US'
import zhLocale from './zh_CN'

Vue.use(VueI18n)

const messages = {
  en_US: {
    ...enLocale
  },
  zh_CN: {
    ...zhLocale
  }
}
// 默认语言为英语
const i18n = new VueI18n({
  fallbackLocale: 'en_US',
  messages
})

export default i18n
